<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑会员级别' : '添加会员级别'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="级别名称">
				<el-input v-model="item.name" placeholder="请输入级别名称"></el-input>
			</el-form-item>
			<el-form-item label="会员级别">
				<el-select v-model="item.level" filterable placeholder="请选择等级权重">
					<el-option v-for="item in weights" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="会员折扣">
				<el-input v-model="item.discount" placeholder="请输入会员折扣,折扣率范围0-10，9.5代表9.5折，0代表不折扣"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	// 生成等级权重
	const weights = []
	for (let i = 1; i <= 20; i++) {
		weights.push(i)
	}

	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				rules: {},
				weights
			}
		},
		created() {
			if (this.id) {
				this.loadData()
			}
		},
		methods: {
			loadData: function() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/store/member.level/detail', {
					params: {
						id: this.id
					}
				}).then(res => {
					this.isLoad = !this.isLoad
					this.item = res.data.detail
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let url = ''
				if (this.id) {
					url = '/store/member.level/edit'
					this.item.id = this.id
					this.axios.put(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
				} else {
					url = '/store/member.level/add'
					this.axios.post(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
				}

			}
		}
	}
</script>
<style scoped>
</style>
